import axios from 'axios';
const BASE_URL = "https://api.stamenssoftware.com";
export const apiRequest = async ({ url, method,  data, header}) => {
  try {

    const response = await axios({
     url: BASE_URL + url,
      method,
      headers: header ? header : {
        'Content-Type': 'application/json',
      },
      data, 
    });

    return response.data; 
  } catch (error) {

    throw new Error(error.response?.data?.message || error.message || 'An error occurred while making the API request.');
  }
};
